import { useEffect, useRef, useCallback } from 'react';

export function useKeydownOnce(key, action, delay = 300) {
  const keyIsDown = useRef(false);
  const timeoutId = useRef(null);

  // Memoize action to ensure it's stable between renders
      // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableAction = useCallback(action, []);

  const onKeyDown = useCallback((e) => {
    if (e.key === key && !keyIsDown.current) {
      e.preventDefault();
      stableAction();
      keyIsDown.current = true;

      // Set a timeout to prevent the action from being triggered again within the delay period
      timeoutId.current = setTimeout(() => {
        keyIsDown.current = false;
      }, delay);
    }
  }, [key, stableAction, delay]);

  const onKeyUp = useCallback((e) => {
    if (e.key === key) {
      e.preventDefault();

      // Clear the timeout if the key is released before the delay period ends
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }

      keyIsDown.current = false;
    }
  }, [key]);

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyDown, onKeyUp]);
}